import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Paper, Table, TableHead, TableRow, TableCell, TableBody, Chip, Typography } from '@mui/material';
import PageHeader from '../../components/common/PageHeader';
import { loadPortalData } from '../slices/portalSlice';
import { severityChipSx, severityLabel } from '../../utils/severity';
import { tokens } from '../../theme/theme';

const STATUS_LABEL = {
  open: { label: 'Open', color: tokens.severity.critical },
  'in-progress': { label: 'In Progress', color: tokens.severity.medium },
  in_remediation: { label: 'In Remediation', color: tokens.severity.medium },
  remediated: { label: 'Remediated', color: tokens.severity.low },
  accepted_risk: { label: 'Accepted Risk', color: tokens.severity.medium },
  false_positive: { label: 'False Positive', color: tokens.text.muted },
  resolved: { label: 'Resolved', color: tokens.severity.low }
};

export default function PortalVulnerabilitiesPage() {
  const dispatch = useDispatch();
  const { vulnerabilities } = useSelector((s) => s.portal);

  useEffect(() => { dispatch(loadPortalData()); }, [dispatch]);

  return (
    <Box>
      <PageHeader
        title="Vulnerabilities"
        subtitle="Findings identified across your monitored websites and infrastructure"
      />

      <Paper sx={{ overflow: 'hidden' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {['ID', 'Finding', 'Severity', 'Status', 'Detected'].map((h) => (
                <TableCell key={h} sx={{ color: tokens.text.muted, fontSize: '0.68rem', textTransform: 'uppercase' }}>{h}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {vulnerabilities.map((v) => (
              <TableRow key={v.id} hover>
                <TableCell sx={{ fontFamily: '"JetBrains Mono", monospace', fontSize: '0.75rem', color: tokens.text.muted }}>{v.id}</TableCell>
                <TableCell sx={{ fontSize: '0.82rem', color: tokens.text.primary }}>{v.title}</TableCell>
                <TableCell><Chip label={severityLabel(v.severity)} size="small" sx={severityChipSx(v.severity)} /></TableCell>
                <TableCell>
                  <Chip
                    label={(STATUS_LABEL[v.status] || { label: v.status, color: tokens.text.muted }).label} size="small"
                    sx={{ color: (STATUS_LABEL[v.status] || { color: tokens.text.muted }).color, border: `1px solid ${(STATUS_LABEL[v.status] || { color: tokens.text.muted }).color}`, backgroundColor: 'transparent' }}
                  />
                </TableCell>
                <TableCell sx={{ fontSize: '0.76rem', color: tokens.text.secondary }}>{v.detected}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Typography variant="caption" sx={{ color: tokens.text.muted, display: 'block', mt: 2 }}>
        Questions about a finding? Open a ticket from the Support page and reference the finding ID.
      </Typography>
    </Box>
  );
}
